import './_vportal.js';

window.addEventListener("load", function () {
    new Swiper(".swiper-banner", {
        autoplay: {
            delay: 4000,
        },
    });

    $(".news").each(function () {
        var postsTag = "#" + $(this).attr("id");
        $().vPortal({
            container: postsTag,
            el: {
                tabContainer: '.news-tabs > a',
                resultContainer: '.news-list',
                viewAll: '.viewAll',
            },
            paginationOptions: {
            }
        });

    });

});